module.exports = __webpack_public_path__ + "static/media/data-analysis-img-1.141015d5.svg";